export default "__VITE_ASSET__CJ3dzlks__"